import App from './App.svelte';

const app = new App({
  target: document.body
});
document.getElementById('public-fallback')?.remove();

export default app;
